import React, {useEffect, useState} from "react";
import {BasicProps} from "../Main";
import {Grid} from "@mui/material";
import {Colours, SamaggiTypography} from "../Components/SamaggiTypography";
import {SamaggiButton} from "../Components/SamaggiButton";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {handleError} from "../support";
import {SamaggiField} from "../Components/SamaggiFields";
import SamaggiPaper from "../Components/SamaggiPaper";

export const Email: React.FC<BasicProps> = (props) => {
    const [pageLoaded, setPageLoaded] = useState(false);
    const [accountExists, setAccountExists] = useState(false);
    const [quota, setQuota] = useState(0);
    const [usage, setUsage] = useState(0);
    const [email, setEmail] = useState("");

    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        props.setShowCover(true);
        load() // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function load() {
        props.setShowCover(true);

        const token = localStorage.getItem("token");

        axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/email/check-quota", {
            "token": token
        }).then((res) => {
            setPageLoaded(true);
            props.setShowCover(false);

            if (res.data.data.forwarderUpdated) {
                alert("Your team assignment has been updated successfully");
            }

            setAccountExists(res.data.data.exists);
            setEmail(res.data.data.email);

            if (res.data.data.exists) {
                 setQuota(res.data.data.quota);
                 setUsage(res.data.data.usage);
            }
        }).catch((error) => {
            props.setShowCover(false);
            handleError(error, true);
        })
    }

    function create() {
        if (password !== password2) {
            alert("Please make sure your passwords match.");
            return
        }

        if (password.length < 8 || password.toLowerCase() === password || password.toUpperCase() === password || !/\d/.test(password)) {
            alert("Your password must contain at least 8 characters, one upper-cased character and one lower-cased character and a number.");
            return
        }

        props.setShowCover(true);

        const token = localStorage.getItem("token");

        axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/email/create", {
            "token": token,
            "password": password
        }).then((res) => {
            setPageLoaded(true);
            props.setShowCover(false);

            console.log(res);
            window.location.reload();
        }).catch((error) => {
            props.setShowCover(false);
            handleError(error, true);
        })
    }

    function reset() {
        if (password !== password2) {
            alert("Please make sure your passwords match.");
            return
        }

        if (password.length < 8 || password.toLowerCase() === password || password.toUpperCase() === password || !/\d/.test(password)) {
            alert("Your password must contain at least 8 characters, one upper-cased character and one lower-cased character and a number.");
            return
        }

        props.setShowCover(true);

        const token = localStorage.getItem("token");

        axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/email/password-reset", {
            "token": token,
            "password": password
        }).then((res) => {
            setPageLoaded(true);
            props.setShowCover(false);

            alert("Your password was reset successfully.");
            console.log(res);
            window.location.reload();
        }).catch((error) => {
            props.setShowCover(false);
            handleError(error, true);
        })
    }

    return (
        <>
            <Grid container direction={"column"} spacing={3}>
                {pageLoaded && accountExists && <Grid item container direction={"column"} spacing={2}>
                    <Grid item container direction={"column"} spacing={3}>
                        <Grid item>
                            <SamaggiTypography center xlarge bold>Samaggi Email Account</SamaggiTypography>
                        </Grid>
                        <Grid item>
                            <SamaggiTypography center small>Our records show that you already have a Samaggi Samagom email account. You can view your quota usage, reset your password and access the Webmail client below.</SamaggiTypography>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <SamaggiPaper internal>
                            <Grid item container direction={"column"} spacing={1}>
                                <Grid item>
                                    <SamaggiTypography bold>Your Email Address</SamaggiTypography>
                                </Grid>
                                <Grid item>
                                    <SamaggiTypography center breakAnywhere>{email}</SamaggiTypography>
                                </Grid>
                            </Grid>
                        </SamaggiPaper>
                    </Grid>
                    <Grid item>
                        <SamaggiPaper internal>
                            <Grid item container direction={"column"} spacing={2}>
                                <Grid item>
                                    <SamaggiTypography bold>Usage and Quotas</SamaggiTypography>
                                </Grid>
                                <Grid item container direction={"column"} spacing={1}>
                                    <Grid item>
                                        <SamaggiTypography bold center>Current Usage</SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography center large>{usage} MB of {quota} MB</SamaggiTypography>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <SamaggiTypography center small>If you are approaching your limit, please contact the IT team to request for an increase in quota. You can delete emails to reduce your usage.</SamaggiTypography>
                                </Grid>
                            </Grid>
                        </SamaggiPaper>
                    </Grid>
                    <Grid item>
                        <SamaggiPaper internal>
                            <Grid item container direction={"column"} spacing={2}>
                                <Grid item container direction={"column"} spacing={1}>
                                    <Grid item>
                                        <SamaggiTypography bold>Reset Your Password</SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography xsmall>You will have to re-login to your email clients if you reset your password. Your password must contain at least 8 characters, and must contain at least 1 lower-cased character, 1 upper-cased character and 1 number.</SamaggiTypography>
                                    </Grid>
                                </Grid>
                                <Grid item container spacing={1}>
                                    <Grid item xs={12}>
                                        <SamaggiField label={"New Password"} fullWidth autoComplete={"new-password"} type={"password"} value={password} onChange={(e) => {setPassword(e.target.value)}} error={password2 !== password} required></SamaggiField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <SamaggiField label={"Confirm Password"} fullWidth autoComplete={"new-password"} type={"password"} value={password2} onChange={(e) => {setPassword2(e.target.value)}} error={password2 !== password} required></SamaggiField>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <SamaggiButton fullWidth onClick={() => {reset()}}>Reset Password</SamaggiButton>
                                </Grid>
                            </Grid>
                        </SamaggiPaper>
                    </Grid>
                    <Grid item>
                        <SamaggiPaper internal>
                            <Grid item container direction={"column"} spacing={1}>
                                <Grid item>
                                    <SamaggiTypography bold>Quick Links</SamaggiTypography>
                                </Grid>
                                <Grid item container direction={"column"} spacing={1}>
                                    <Grid item>
                                        <SamaggiButton fullWidth onClick={() => {window.open("https://webmail.samaggisamagom.com", "_blank")}}>Go to Webmail</SamaggiButton>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiButton fullWidth onClick={() => {window.open("https://docs.samaggisamagom.com/User+Guide/Using+Your+Samaggi+Samagom+Email+Account", "_blank")}}>Email Help & FAQ</SamaggiButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </SamaggiPaper>
                    </Grid>
                </Grid>}
                {pageLoaded && !accountExists && <Grid item container direction={"column"} spacing={4}>
                    <Grid item container direction={"column"} spacing={3}>
                        <Grid item>
                            <SamaggiTypography center xlarge bold>Create your Samaggi Email Account</SamaggiTypography>
                        </Grid>
                        <Grid item>
                            <SamaggiTypography center small>Our records show that you do not currently have a Samaggi Samagom account, enter your password below to set a new password. Your email address is also shown below.</SamaggiTypography>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <SamaggiTypography bold center>{email}</SamaggiTypography>
                    </Grid>
                    <Grid item container spacing={1}>
                        <Grid item xs={12}>
                            <SamaggiField label={"New Password"} fullWidth autoComplete={"new-password"} type={"password"} value={password} onChange={(e) => {setPassword(e.target.value)}} error={password2 !== password} required></SamaggiField>
                        </Grid>
                        <Grid item xs={12}>
                            <SamaggiField label={"Confirm Password"} fullWidth autoComplete={"new-password"} type={"password"} value={password2} onChange={(e) => {setPassword2(e.target.value)}} error={password2 !== password} required></SamaggiField>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <SamaggiButton fullWidth onClick={() => {create()}}>Create Account</SamaggiButton>
                    </Grid>
                </Grid>}
                <Grid item>
                    <SamaggiButton fullWidth colour={Colours.gray} hoverColour={Colours.darkGray} onClick={() => {navigate("/")}}>Back to Staff Portal</SamaggiButton>
                </Grid>
            </Grid>

        </>
    )

}